export const TRACKING_EVENT = 'GAEvent';
export const TRACKING_CATEGORY = 'User Account';
